import { Injectable } from "@angular/core";
import { ApiReadAction, ApiEditAction } from "../../api-actions";
import { ApiSessionService } from "../../api-session.service";
import { ApiStateStoreService } from "../../api-state-store.service";
import { sessionId } from "../../apiParams/session-id";
import { extractData, OnsipApiResponse } from "../../apiResponse/response-body-new";
import { getApiActionName } from "../../onsip-api-action-new";
import { arrayToRecord } from "../../util/arrayToRecord";
import { ApiResourceService } from "../api-resource.service";
import {
  OrganizationCustomizationAvatarParams,
  ApiOrganizationCustomizationAvatar,
  OrganizationCustomizationAvatar,
  apiOrganizationCustomizationAvatarToOrganizationCuztomizationAvatar as clean
} from "./organization-customization-avatar";
import { ApiPromiseState, ApiPromiseStateService } from "../../api-promise-state.service";

const debug = false;

@Injectable({ providedIn: "root" })
export class OrganizationCustomizationAvatarService extends ApiResourceService<OrganizationCustomizationAvatar> {
  constructor(
    session: ApiSessionService,
    store: ApiStateStoreService,
    promiseState: ApiPromiseStateService
  ) {
    super(session, store, promiseState, "OrganizationCustomizationAvatar", "" as never);
    debug &&
      this.state.subscribe(state => console.warn("OrganizationCustomizationAvatarService", state));
  }

  organizationCustomizationAvatarRead(
    params: OrganizationCustomizationAvatarParams
  ): ApiPromiseState<OrganizationCustomizationAvatar> {
    this.dispatcher.next({
      parameters: {
        Action: ApiReadAction.OrganizationCustomizationAvatarRead,
        SessionId: this.store.state.pipe(sessionId()),
        ...params
      }
    });
    return this.promiseState.toPromise(ApiReadAction.OrganizationCustomizationAvatarRead);
  }

  organizationCustomizationAvatarEdit(
    params: OrganizationCustomizationAvatarParams
  ): ApiPromiseState<OrganizationCustomizationAvatar> {
    this.dispatcher.next({
      parameters: {
        Action: ApiEditAction.OrganizationCustomizationAvatarEdit,
        SessionId: this.store.state.pipe(sessionId()),
        ...params
      }
    });
    return this.promiseState.toPromise(ApiEditAction.OrganizationCustomizationAvatarEdit);
  }

  reducer(response: OnsipApiResponse): void {
    const action = getApiActionName(response);
    switch (action) {
      case ApiReadAction.OrganizationCustomizationAvatarRead:
      case ApiEditAction.OrganizationCustomizationAvatarEdit:
        this.store.mergeStateUpdate(
          this.resourceName,
          arrayToRecord(
            [
              extractData<ApiOrganizationCustomizationAvatar>(
                response,
                action,
                "OrganizationCustomization"
              )
            ].map(clean),
            this.indexKeyName
          ),
          action
        );
        break;
    }
  }
}
